<!-- @format -->

<template>
	<pc-collapse v-model="activeCol" @change="emits('on-template-change', $event)">
		<pc-collapse-item v-for="(item, idx) in templateList" :key="idx" :title="item.label" :name="item.code">
			<draggable
				:list="kitField(item.children)"
				item-key="label"
				class="el-row fields-container"
				v-bind="{
					group: {
						name: 'container',
						pull: 'clone',
						put: false,
					},
					sort: false,
					ghostClass: 'ghost',
					animation: 300,
				}"
			>
				<template #item="{ element }">
					<el-col :span="12" :class="`fields-item fields-item-24`">
						<el-tooltip effect="dark" :content="element.pcProps.label" :show-after="500">
							<div class="fields-item-content"> {{ element.pcProps.label }} </div>
						</el-tooltip>
					</el-col>
				</template>
			</draggable>
		</pc-collapse-item>
	</pc-collapse>
</template>

<script setup lang="ts">
	import { type TemplateType } from '../../../types';
	import { draggable, PcCollapse, PcCollapseItem } from '@/components';

	interface Props {
		templateList?: TemplateType[];
	}

	withDefaults(defineProps<Props>(), {});

	const emits = defineEmits(['on-template-change']);

	const activeCol = ref<string[]>([]);

	const kitField = (itm) => {
		return itm.map((it) => ({
			category: 'container',
			type: 'card',
			children: it.widgetDatas,
			pcProps: {
				label: it.label,
				cols: '24',
				hidden: false,
				defaultOpen: true,
				code: it.code,
			},
		}));
	};
</script>

<style scoped lang="scss">
	.fields-container {
		.fields-item {
			font-size: 12px;
			line-height: 30px;
			padding: 3px;

			.fields-item-content {
				padding: 1px;
				border: 1px solid var(--el-border-color-light);
				border-radius: 4px;
				cursor: move;
				background: #ffffff;
				display: flex;
				align-items: center;

				.el-icon {
					font-size: 15px;
					margin: 0 10px 0 5px;
				}
			}

			.fields-item-content:hover {
				color: var(--el-color-primary);
				border: 1px dashed var(--el-color-primary);
				border-radius: 4px;
			}

			.fields-item-content > span {
				// 字段过长省略
				display: inline-block;
				vertical-align: middle;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
				width: 100%;
			}
		}
	}
</style>
